import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CommonService} from '@service/common/common.service';
import {endpoints} from '../../../configs/endpoints/endpoint';
import {HttpService} from '@service/http/http.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  constructor(private httpClient: HttpClient, private common: CommonService,
              private http: HttpService) {
  }


  public catalogDetail(categoryId: number): Observable<any> {
    return this.http.post(endpoints.category.detail, {categoryId});
  }

  public modelList(categoryId: number): Observable<any> {
    return this.http.post(endpoints.product.model.list, {categoryId});
  }

  public catalogIndex(): Observable<any> {
    return this.http.post(endpoints.category.index, {});
  }

  public categoryList(categoryParams: any): Observable<any> {
    return this.http.post(endpoints.category.list, categoryParams);
  }
}
